import React from "react";
import ThreeCrossTwo from "../components/modules/ThreeCrossTwo";
import Herocamp from "../components/modules/Herocamp";
import Menu from "../components/modules/Menu";
import Seo from "../components/modules/Seo";
import NameChange from "../components/modules/NameChange";
import NewBranch from "../components/modules/NewBranch";
const objSeo = {
  title: "Kote Cafe (formerly Idly Dosa Camp) - Authentic South Indian Cuisine in Bagalkot",
  keywords:
    " Kote Cafe, Idly Dosa Camp, South Indian cuisine, authentic, Bagalkot, menu, delicious dishes, specialty, idly, dosa, classic, cravings",
  pathSlug: "/kotecafe",
  baseUrl: "https://bitbytefoods.com/",
  description:
    "Welcome to KOTE CAFE (formerly Idly Dosa Camp), your premier destination for authentic South Indian cuisine located in Shop No.2, Jain Mandir Complex, Vidyagiri-Bagalkot. Our menu offers a wide variety of delicious dishes, but our specialty lies in the classic South Indian favorites - idly and dosa.",
};
const Camp = () => {
  return (
    <div>
      <Seo data={objSeo} />
      <Herocamp />
      <NameChange />
      <NewBranch />
      <ThreeCrossTwo />
      <Menu />
    </div>
  );
};

export default Camp;
